import React, {useEffect, useRef, useState} from 'react';

import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {ConfirmDialogService, FormatDisplay, IamColumn, ToastService, useDataTableBasic, useDialogCrup} from '@iamsoftware/react-hooks';

import {AgreementService, AgreementService as Service} from './AgreementService';
import {SignService} from '../../../service/SignService';
import { DocumentSignService } from '../../../service/DocumentSignService';

export const AgreementFile = ({display, setDisplay, reloadLazyData}) => {

  const dataKey = 'roleTypeId'

  const [signatureData, setSignatureData] = useState([]);
  const [agreementParties, setAgreementParties] = useState([])
  const [displayFile, setDisplayFile] = useState(null);
  const [agreementStatus, setAgreementStatus] = useState([''])

  useEffect(() => {
    if (display?.status) {
      setAgreementStatus(display?.status)
    }
  }, [display?.status])
  const onEditorChange = (rowData, column, newValue) => {
    setSignatureData(prevItems => prevItems.map(prevItem => {
      if (prevItem[dataKey] === rowData[dataKey]) {
        return {
          ...prevItem,
          [column.field]: newValue
        }
      }
      return prevItem;
    }));
  }
  const inject = async item => {
    if (item.contentFile.length) {
      item.contentFile = item.contentFile[0];
    }
    signatureData.map(data => {
      if (data.isSigned === true) {
        data.isSigned = "Y"
      } else {
        data.isSigned = "N"
      }
      if (data.signedDate) {
        data.signedDate = Date.parse(data.signedDate)
      }
      delete data.roleType
      delete data.sequenceNum
      delete data.status
      delete data.agreementId
      delete data.statusId
    })
    item.signatureData = JSON.stringify(signatureData)
    return Service.toFormData(item)
  }
  const signInfoTable = useDataTableBasic({
    tableHeader: 'Ký xác thực',
    indexColumnWidth: 45,
    columns: [
      {field: 'roleType', header: 'Vai trò', width: 150},
      {
        field: 'isSigned', header: 'Đã ký', width: 120,
        dataType: 'editor', editorConfig: {
          onEditorChange,
          field: {type: 'Checkbox'}
        }, className: 'text-center'
      },
      {
        field: 'signedDate', header: 'Ngày ký', width: 150, dataType: 'editor', editorConfig: {
          onEditorChange,
          field: {
            InputTextProps: {type: 'date'}, disabledDependency(item: any): boolean {
              return item.isSigned === false
            }
          }
        }, className: 'text-center'
      },
      {
        field: 'description', header: 'Đối tượng ký', width: 200,
        dataType: 'editor', editorConfig: {
          onEditorChange,
          field: {
            disabledDependency(item: any): boolean {
              return item.isSigned === false
            }
          }
        }
      },

    ],
    items: signatureData,
  })
  const {render: renderDialogCrup, create} = useDialogCrup({
    header: '! Upload File hợp đồng',
    width: '80rem',
    fields: [
      {field: 'contentFile', header: 'File hợp đồng', type: 'file', InputFileProps: {accept: '.pdf'}, className: 'md:col-12'},
      {type: 'custom', body: signInfoTable.render()}
    ],
    createItem: async item => {
      return Service.uploadPDFFile(display?.agreementId, await inject(item)).then(() => {

      });
    },

    useSaveSplitButton: false
  });
  const {render: renderSignAgreement} = useDataTableBasic({
    tableHeader: 'Đối tượng',
    dataKey: 'dataKey',
    indexColumnWidth: 45,
    columns: [
      {
        field: 'checked', header: 'Chọn', width: 120,
        dataType: 'editor', editorConfig: {
          onEditorChange(rowData: any, column: IamColumn, newValue: any) {
            setAgreementParties(prevItems => prevItems.map(prevItem => {
              if (prevItem.dataKey === rowData.dataKey) {
                return {
                  ...prevItem,
                  [column.field]: newValue
                }
              } else {
                return {
                  ...prevItem,
                  [column.field]: false
                }
              }
              return prevItem;
            }));
          },
          field: {type: 'Checkbox'}
        }, className: 'text-center'
      },
      {field: 'partyName', header: 'Tên đối tượng', minWidth: 150},
      {
        header: 'MST/CCCD/CMND', minWidth: 100, dataType: 'custom', customCell(rowData: any): any {
          if (rowData.taxCode) {
            return rowData.taxCode
          } else {
            return rowData.identityCard
          }
        }
      },
      {field: 'roleType', header: 'Vai trò', minWidth: 75},
      {field: 'emailAddress', header: 'Email', minWidth: 75},
      {field: 'contactNumber', header: 'SĐT', minWidth: 75},

    ],
    items: agreementParties
  });
  const signFile = (data) => {
    Service.unsignedParties(data?.agreementId).then(data => {
      setAgreementParties(data.agreementParties.map(field => {
        if (field.checked === "Y") {
          field.checked = true
        } else {
          field.checked = false
        }
        field.dataKey = `${field.roleTypeId}-${field.partyId}`
        return field;
      }))
    })
    setDisplayFile(Date.now());
  }
  const onSubmit = async () => {
    const nhot = []
    agreementParties.map(agreementParty => {
      if (agreementParty.checked === true) {
        nhot.push(agreementParty)
      }
    })
    if (nhot[0]?.agreementId) {
      try {
        const row = nhot[0];
        const signResult = await DocumentSignService.sign({
          referenceNumber: row.agreementId,
          signingSecretCode: '',
          restPath: '/rest/s1/iam-agreement',
          taxCode: row.pseudoId || row.customerPseudoId,
          signedBy: row.roleTypeId === 'SellerSignedExec' ? 'SELLER' : 'BUYER',
          agreementId: row.agreementId,
          partyId: row.partyId,
          roleTypeId: row.roleTypeId
        });

        if (signResult?.success && signResult?.data?.signedFilesBase64?.length > 0) {
          const signedPdfBase64 = signResult.data.signedFilesBase64[0];

          await Service.pushSignedData({
            signedBy: row.roleTypeId === 'SellerSignedExec' ? 'SELLER' : 'BUYER',
            base64FileData: signedPdfBase64,
            agreementId: row.agreementId,
            partyId: row.partyId,
            roleTypeId: row.roleTypeId,
            referenceNumber: null,
            signingSecretCode: ''
          });

          ToastService.success('Ký số thành công và đã lưu file!');
        } else {
          ToastService.error('Ký số thất bại!');

          try {
            await Service.updateSigningError({
              agreementId: row.agreementId,
              partyId: row.partyId,
              roleTypeId: row.roleTypeId,
              referenceNumber: null,
              signingSecretCode: ''
            });
          } catch (apiError) {
            console.error('Error calling updateSigningError API:', apiError);
          }
        }

        try {
          const res = await AgreementService.get(display?.agreementId);
          setAgreementStatus(res.status)
        } catch {}

        setDisplayFile(null)
        reloadLazyData();
      } catch (error) {
        console.error('Error during sign/push in view PDF:', error);
        ToastService.error('Có lỗi khi ký/lưu file từ server.');

        try {
          const row = nhot[0];
          await Service.updateSigningError({
            agreementId: row.agreementId,
            partyId: row.partyId,
            roleTypeId: row.roleTypeId,
            referenceNumber: null,
            signingSecretCode: ''
          });
        } catch (apiError) {
          console.error('Error calling updateSigningError API:', apiError);
        }
      }
    } else {
      ToastService.error('Chưa chọn đối tượng ký.');
    }
  }
  const footer = (
    <div className="flex justify-content-between">
      <div>
        <b className={'pt-2'} style={{color: 'red', fontSize: '20px'}}>Trạng thái: {agreementStatus}</b>
      </div>
      <div>
        {/*{(display?.sellerSignStatusId === 'AGT_PTY_UNSIGNED' && display?.buyerSignStatusId === 'AGT_PTY_UNSIGNED') && <Button label="Upload file ký" icon="pi pi-upload" severity="warning" size="small" onClick={() => inputSignedFile.current.click()}/>}*/}
        {/*{display?.statusId !== "AGT_CREATED" && display?.statusId !== "AGT_SIGNING_PROCESS" && <Button label="Upload file HĐ" icon="pi pi-upload" severity="warning" size="small" onClick={uploadFile}/>}*/}
        {(display?.statusId === "AGT_CREATED" || display?.statusId === "AGT_SIGNING_PROCESS") && <Button label="Ký hợp đồng" icon="pi pi-pencil" severity="success" size="small" onClick={() => signFile(display)}/>}
        {/*{display?.templateAgreementId && <Button label="Tải file Docx" icon="pi pi-download" severity="help" size="small" onClick={downloadFile('docx')}/>}*/}
        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplay(false)}/>
      </div>
    </div>
  );
  const fileFooter = (
    <div>
      {displayFile && <div>
				<Button label="Xác nhận ký" icon="pi pi-check" className=" p-button-success p-button-sm" type="button" onClick={() => onSubmit()}/>
				<Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplayFile(false)}/>
			</div>}
    </div>
  );
  return (
    <Dialog header={`Hợp đồng - ${display?.agreementName || display?.agreementId}`} maximized={true} draggable={false} footer={footer} visible={!!display} style={{width: '80rem', height: '60rem',}} position="top" onHide={() => setDisplay(false)}>
      {display?.agreementId &&
				<iframe src={`${Service.baseURL}/${Service.entity}/${display.agreementId}/pdf?v=${agreementStatus}`} title="Hợp đồng"
								style={{width: '100%', height: '100%', border: 'none'}}/>
      }
      {renderDialogCrup()}
      <Dialog header={`Chọn đối tượng ký`} footer={fileFooter} visible={!!displayFile} style={{width: '80rem', height: '30rem',}} position="center" onHide={() => setDisplayFile(false)}>
        {renderSignAgreement()}
      </Dialog>
    </Dialog>
  );

}